import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';

function StandardTabContent({ categoryPhotos, onImageClick, renderBadge }) {
  return (
    <Row xs={1} md={2} lg={3} className="g-4 justify-content-center">
      {categoryPhotos.map((photo, idx) => (
        <Col key={idx} className="d-flex justify-content-center" style={{ maxWidth: '400px' }}>
          <div 
            className="position-relative w-100" 
            style={{ paddingBottom: '75%', cursor: 'pointer' }}
            onClick={() => onImageClick(photo)}
          >
            <Image
              data-testid="gallery-image"
              src={`photos/${photo}`}
              alt=""
              className="w-100 h-100 rounded shadow position-absolute top-0 start-0"
              style={{ objectFit: 'contain' }}
            />
            {renderBadge && renderBadge()}
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default StandardTabContent;